import { Image, ImageProps, Skeleton } from '@chakra-ui/react';
import { useGetConfig } from '@/services/queries/admin-config';

type LogoProps = ImageProps & {
  variant?: 'white' | 'colorful';
};

export const Logo = ({ variant, ...props }: LogoProps) => {
  const { data: config, isLoading } = useGetConfig();

  const src = variant === 'white' ? config?.logo_login : config?.logo;

  if (isLoading) {
    return <Skeleton minH='100px' w='210px' minW='190px' maxW='220px' borderRadius='8px' />;
  }

  if (!isLoading && !src) {
    return <Image src={undefined} width={210} height='auto' {...props} />;
  }

  return <Image src={src || ''} maxWidth={500} {...props} />;
};
